const createLoginEn = {
  'createLogin': {
    'loginLabel': 'Login',
    'requirementsTitle': 'Login should contain:',
    'requirements': {
      'symbolsCount': 'from {{minLength}} to {{maxLength}} symbols',
      'letters': 'Latin letters or digits',
    },
  },
};

export default createLoginEn;
